import { UnifiedButton } from './unified-button';
import { cn } from '@/shared/lib/cn';

export type StatusVariant = 'active' | 'warning' | 'inactive' | 'error';

interface StatusBadgeProps {
  status: StatusVariant;
  label?: string;
  className?: string;
  onClick?: () => void;
}

const statusConfig: Record<
  StatusVariant,
  { containerClass: string; dotClass: string; textClass: string; defaultLabel: string }
> = {
  active: {
    containerClass: 'bg-positive/10 border border-positive/25',
    dotClass: 'bg-positive shadow-[0_0_5px_var(--color-positive)]',
    textClass: 'text-positive',
    defaultLabel: 'Activo',
  },
  warning: {
    containerClass: 'bg-warn/10 border border-warn/25',
    dotClass: 'bg-warn',
    textClass: 'text-warn',
    defaultLabel: 'Atención',
  },
  inactive: {
    containerClass: 'bg-primary/10 border border-primary/25',
    dotClass: 'bg-primary',
    textClass: 'text-primary',
    defaultLabel: 'Inactivo',
  },
  error: {
    containerClass: 'bg-negative/10 border border-negative/25',
    dotClass: 'bg-negative',
    textClass: 'text-negative',
    defaultLabel: 'Error',
  },
};

export function StatusBadge({ status, label, className, onClick }: StatusBadgeProps) {
  const cfg = statusConfig[status];
  const baseClass = cn(
    'inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full',
    cfg.containerClass,
    onClick && 'cursor-pointer hover:opacity-80 transition-opacity',
    className,
  );
  const content = (
    <div className="flex items-center gap-1.5">
      <div className={cn('w-1.5 h-1.5 rounded-full flex-shrink-0', cfg.dotClass)} />
      <span className={cn('text-[0.625rem]', cfg.textClass)}>{label ?? cfg.defaultLabel}</span>
    </div>
  );

  if (onClick) {
    return (
      <UnifiedButton type="button" onClick={onClick} className={baseClass}>
        {content}
      </UnifiedButton>
    );
  }

  return <div className={baseClass}>{content}</div>;
}
